/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from 'react';
import { IoIosArrowDown } from "react-icons/io";
import { BsStars } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import { MdReviews,MdPayment,MdPermPhoneMsg  } from "react-icons/md";

import { BiLogoTelegram } from 'react-icons/bi';
import { AiFillMessage } from "react-icons/ai";

import { SiGoogleads } from 'react-icons/si';
import { HiChatBubbleOvalLeft } from 'react-icons/hi2';
import { TiSocialInstagram } from "react-icons/ti";
import { IoMdClose } from "react-icons/io";

import elyzian from "../../Assets/lolo.png";
import { ImBullhorn } from "react-icons/im";

import { FaStore } from "react-icons/fa";
import { GiTicket } from "react-icons/gi";
import bg from '../../Assets/Background.png'


import small from "../../Assets/elyzian.png";

import { Link, Outlet } from 'react-router-dom';

const NavigationMenu = ({ options,setshowMarketing }) => {
  const closePopUp = (ref) => {
    useEffect(() => {     
      const handleClickOutside = (event) => {
        // console.log('ref event',event,ref);
        if (ref.current && !ref.current.contains(event.target)) {
          setshowMarketing(false);
          // alert('clicked outside');
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
    
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);
  const navigate = useNavigate();
  closePopUp(wrapperRef);
  return (
    <div ref={wrapperRef}  className="absolute w-full py-[40px] left-0 scale-in-ver-top z-10  min-h-[250px] bg-white border-y shadow-lg text-black overflow-y-auto sm:overflow-hidden top-[71px]">
      <div className='w-full flex px-10 mb-10 sm:hidden'> <button onClick={() => {navigate('/waitlist'); setshowMarketing(false)}} className="flex w-full items-center justify-center gap-2 text-sm  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
  <span className="button-content medium">Join our waitlist </span>
  <span className="star-icon"><BsStars className="text-yellow-300" /></span>
</button>
</div>

      <div className="py-3 flex flex-wrap pl-[20px] gap-4 sm:gap-10 sm:px-[40px]  border-[#383e47] fade-in">
        { options?.map((e) => (
          <div
            key={e.id}
            onClick={() => {
              if (typeof e.onClick === 'function') {
                e.onClick();
              } else {
                navigate(e.onClick);
                setshowMarketing(false);
              }
            }}
            className="flex w-[400px] border border-transparent hover:border-gray-200 hover:bg-gray-50  rounded-xl items-center gap-3 px-5 py-3 text-xs lg:text-sm cursor-pointer"
          >
            <span className="text-base xl:text-[30px] text-blue-600">{e.icon}</span>
            <span className="medium xl:semibold">{e.text}</span>
          </div>
        ))}

      </div>
    </div>

  ); 
};



function Navbar() {
    const navigate = useNavigate()
    const [showMarketing, setshowMarketing] = useState(false);

    const MarketingOptions = [
      {
        id: 1,
        icon: <FaStore />,
        text: 'Business Management',
        onClick: '/business-management',
      },
      {
        id: 2,
        icon: <MdReviews />,
        text: 'Reviews Management',
        onClick: '/reviews-management',
      },
      {
        id: 3,
        icon:<TiSocialInstagram /> ,
        text: 'Social Media Management',
        onClick: '/social-management',
      },
      {
        id: 4,
        icon:<ImBullhorn />,
        text: 'Marketing Management',
        onClick: '/marketing-management',
      },
      {
        id: 5,
        icon: <AiFillMessage />,
        text: 'Messaging Management',
        onClick: '/messaging-management',
      },
      {
        id: 6,
        icon: <GiTicket  />,
        text: 'Ticketing Management',
        onClick: '/ticketing-management',
      },
      {
        id: 7,
        icon: <MdPermPhoneMsg  />,
        text: 'Contact Center Management',
        onClick: '/contact-center',
      },
      {
        id: 8,
        icon: <SiGoogleads />,
        text: 'Advertisement Management',
        onClick: '/ad-management',
      },
      {
        id: 9,
        icon: <MdPayment />,
        text: 'Payments',
        onClick: '/payments',
      },
    ];
 
   

  return (
    <div className={`${ showMarketing ? 'sticky top-0' : 'relative' } bg-white z-10 flex  w-full items-center justify-between px-4 pl-[26px] sm:px-[60px]  py-[12px] tracking-wide h-[4.44rem] text-[#9EA9B8] `}>

    <div className={`flex justify-between w-full text-[.845rem] items-center  gap-2 tracking-wider `}>
        <div className='flex items-center  sm:gap-[50px]'>
          <div onClick={() => navigate('/')} className='w-[130px] aspect-auto cursor-pointer'>
            <img src={elyzian} className='hidden sm:block' alt="" />
            <img src={small} className='sm:hidden w-9' alt="" />

          </div>
            <div className='w-max'>
      <div className="hidden sm:block">     
      {/* <Link to="/inbox"> */}
        <div onClick={() => setshowMarketing(true)} className="cursor-pointer h-full flex items-center gap-1 nav justify-center  min-w-[4.5rem]   ">
          <span className="medium  flex items-center justify-center  rounded-lg w-full    ">
            Products
          </span>
          <IoIosArrowDown className="mt-[1px]" />
        </div>
        {/* {showMarketing && <NavigationMenu setshowMarketing={setshowMarketing} options={MarketingOptions} /> } */}
      {/* </Link> */}
      </div>
      </div>
      {/* <div onClick={() => setshowMarketing(true)} className='text-[25px]  sm:hidden text-black'>
      <GiHamburgerMenu />
      </div> */}
      </div>
      <div onClick={() => setshowMarketing(true)} className='text-[25px]   sm:hidden text-black'>
        {showMarketing ? <div onClick={() => setshowMarketing(false) }><IoMdClose /></div> : <GiHamburgerMenu />}
      
      
      </div>
      

      <div className="hidden sm:block">
      <div className="flex gap-3 ">
      {/* <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm  sm:text-[14px]  tracking-wide rounded-lg hover:shadow  hover:ring-[2px] bold px-3 py-2 sm:px-5  sm:p-[12px] bg-[#f3f5ff] text-[#1e47f6] border border-[#1e47f6] border-opacity-25 hover:transition hover:delay-200">
  <span className="button-content medium">Login </span>
</button> */}
  <a
        href="https://app.elyzian.in/login"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 text-sm sm:text-[14px] tracking-wide rounded-lg hover:shadow hover:ring-[2px] bold px-3 py-2 sm:px-5 sm:p-[12px] bg-[#f3f5ff] text-[#1e47f6] border border-[#1e47f6] border-opacity-25 hover:transition hover:delay-200"
      >
        <span className="button-content medium">Login</span>
      </a>
      <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
  <span className="button-content medium">Join our waitlist </span>
  <span className="star-icon"><BsStars className="text-yellow-300" /></span>
</button>
      </div>
      </div>
    

 
    </div>
    {showMarketing && <NavigationMenu setshowMarketing={setshowMarketing} options={MarketingOptions} /> }

    </div>
  )
}

export default Navbar
